import RegistrationLayout from "@Components/RagistrationLayout";
import { theme } from "@Definitions/Styled";
import { Button, Typography } from "@mui/material";
import { StyledGreenButton } from "@Styled/Common";
import React, { useEffect } from "react";
import { useState } from "react";
// import OtpInput from "react-otp-input-rc-17";
import Spinner from "./Spinner";
import dynamic from "next/dynamic";
// const OtpInput = dynamic(() => import("react-otp-input-rc-17"), { ssr: false });
import { OTPInput, SlotProps, REGEXP_ONLY_DIGITS } from "input-otp";

export function Slot(props: SlotProps) {
  return (
    <div
      style={{
        width: "40px",
        height: "60px",
        fontSize: "24px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        outline: props.isActive ? "2px solid #00844a" : "none",
        position: "relative",
      }}
    >
      {props.char ?? ""}
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  );
}

export function FakeCaret() {
  return (
    <div
      style={{
        position: "absolute",
        width: "1px",
        height: "1.5rem",
        backgroundColor: "black",
        animation: "blink 1s infinite",
      }}
    />
  );
}

interface OtpVerificationComponentProps {
  title?: string;
  subTitle?: string;
  handleSubmit: Function;
  handleResendAnOtp?: Function;
  spinner: Boolean;
  isOtpError: Boolean;
}

export default function OtpVerificationComponent({
  title,
  subTitle,
  handleSubmit,
  isOtpError,
  handleResendAnOtp,
  spinner,
}: OtpVerificationComponentProps) {
  const countDown = 59;
  const [counter, setCounter] = useState<number>(countDown);
  const [OTP, setOTP] = useState<string>("");
  const [isOtp, setIsOtp] = useState<boolean>(false);

  const handleOtpSubmit = async () => {
    await handleSubmit(OTP);
    setIsOtp(true);
  };

  useEffect(() => {
    setIsOtp(false);
  }, [OTP]);

  const handleResendOtpSubmit = () => {
    setCounter(countDown);
    handleResendAnOtp!();
  };

  React.useEffect(() => {
    let Timer: any;
    Timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval!(Timer);
  }, [counter]);

  return (
    <RegistrationLayout
      title={title ? title : "Enter OTP"}
      subTitle={subTitle}
      loginModal={true}
    >
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <OTPInput
            maxLength={4}
            value={OTP}
            onChange={setOTP}
            inputMode="numeric"
            pattern={REGEXP_ONLY_DIGITS}
            render={({ slots }) => (
              <div style={{ display: "flex", gap: "8px" }}>
                {slots.map((slot, idx) => (
                  <Slot key={idx} {...slot} />
                ))}
              </div>
            )}
          />
        </div>
        <>
          {counter !== 0 ? (
            <div
              style={{
                margin: "1rem 0 1rem 0",
                float: "right",
                color: "#00844a",
                fontSize: "14px",
              }}
            >
              RESEND OTP IN {counter} SEC
            </div>
          ) : (
            <Button
              style={{ margin: "0.5rem 0 0.5rem 0", float: "right" }}
              onClick={handleResendOtpSubmit}
            >
              Resend
            </Button>
          )}
        </>
        <StyledGreenButton
          fullWidth
          onClick={handleOtpSubmit}
          disabled={OTP.length == 4 ? false : true}
        >
          {spinner ? <Spinner spinColor={theme.palette.neutral.main} /> : ""}{" "}
          Verify
        </StyledGreenButton>
        {isOtpError && isOtp && OTP.length == 4 ? (
          <Typography style={{ color: "red", textAlign: "center" }}>
            You have entered incorrect OTP.
          </Typography>
        ) : (
          ""
        )}
      </>
    </RegistrationLayout>
  );
}
